export class LocationListModel {
  public ID: string;

  public Title: string;

  public Lat: number;

  public Lng: number;

  public Icon: string;

  /**
   * @title the name of the location
   *
   * @lat the latitude of the location
   *
   * @lng the longitude of the location
   *
   * @icon the url path for the icon belonging to the location
   */

  constructor(title: string, lat: number, lng: number, icon: string) {
    this.Title = title;
    this.Lat = lat;
    this.Lng = lng;
    this.Icon = icon;
  }
}
